import './SellerSection.css';
import defaultImageUpload from '../../img/default-image-upload.svg';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

const SellerSection = () => {

    const isLoggedIn = localStorage.getItem("sessionId")

    const history = useHistory();

    const [productName, setProductName] = useState("");
    const [price, setPrice] = useState("");
    const [discount, setDiscount] = useState("");
    const [category, setCategory] = useState("Produk Lokal");
    const [productInformation, setProductInformation] = useState("");
    const [imageInput, setImageInput] = useState("");

    const handleProductNameInput = (e) => {
        setProductName(e.target.value);
    }

    const handlePriceInput = (e) => {
        setPrice(e.target.value)
    }

    const handleDiscountInput = (e) => {
        setDiscount(e.target.value)
    }

    const handleCategoryInput = (e) => {
        setCategory(e.target.value)
        console.log(category);
    }

    const handleProductInformationInput = (e) => {
        setProductInformation(e.target.value)
    }

    const loadFile = (event) => {
        let productImageOutput = document.getElementById('output');
        productImageOutput.src = URL.createObjectURL(event.target.files[0]);
        let file = document.querySelector("#file-input").files[0];
        let sellBtn = document.getElementById("sellnow-btn");
        sellBtn.style.backgroundColor = "#0476D0";
        // let base64img = await toBase64(file);
        let base64String = "";
        let reader = new FileReader();
        reader.onload = function () {
            base64String = reader.result.replace("data:", "")
                .replace(/^.+,/, "");
            setImageInput(base64String);
        }
        reader.readAsDataURL(file);
    }

    const handleSellButton = async (e) => {
        let productNameInputValue = document.getElementById("productname-input").value;
        let priceInputValue = document.getElementById("price-input").value;
        let discountInputValue = document.getElementById("discount-input").value;
        let descriptionInputValue = document.getElementById("description-input").value;
        if (
            productNameInputValue == "" ||
            priceInputValue == "" ||
            discountInputValue == "" ||
            descriptionInputValue == ""
        ) {
            Swal.fire({
                title: "Mohon isi informasi dengan lengkap.",
                icon: "warning",
                showCancelButton: false,
                showConfirmButton: false,
                timer: 1000
            });
        } else {
            e.preventDefault();
            let data = new FormData();
            data.append("image", imageInput)
            const response = await fetch('https://api.imgbb.com/1/upload?key=1552a9778a566f3a0b9ce61f66964b48', {
                method: 'POST',
                body: data,
                timeout: 0,
                processData: false,
                mimeType: "multipart/form-data",
                contentType: false
            })
                .then(res => res.json());

            console.log(response)
            console.log(response.data.image.url)

            let sessionId = localStorage.getItem("sessionId");

            const productData = JSON.stringify({
                productName,
                price,
                discount,
                category,
                productInformation,
                imageUrl: response.data.image.url
            });

            const productUploadResponse = await fetch("https://backend-markopedia.herokuapp.com/api/seller/product/products", {
                method: "POST",
                body: productData,
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + sessionId
                }
            })
                .then(res => res.json());
            if (productUploadResponse.status === "OK") {
                Swal.fire({
                    title: "Produk berhasil ditambahkan!",
                    icon: "success",
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 1000
                });
                history.push("/");
            } else {
                Swal.fire({
                    title: "Produk gagal ditambahkan. Mohon isi kembali.",
                    icon: "error",
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 1200
                });
            }
        }
    }



    return (
        <>{
            isLoggedIn ?
                <div className="sellersection-wrapper">
                    <div className="seller-section-input">
                        <input onChange={handleProductNameInput} id="productname-input" type="text" placeholder="Nama Produk"></input>
                        <div className="seller-section-priceandstock-wrapper">
                            <input onChange={handlePriceInput} id="price-input" type="text" placeholder="Harga Produk"></input>
                            <input onChange={handleDiscountInput} id="discount-input" type="text" placeholder="Diskon (Opsional)"></input>
                            <select id="category-input" onChange={handleCategoryInput} value={category}>
                                <option value="Produk Lokal">Produk Lokal</option>
                                <option value="Elektronik">Elektronik</option>
                                <option value="Perlengkapan Olahraga">Perlengkapan Olahraga</option>
                                <option value="Pakaian">Pakaian</option>
                                <option value="Properti">Properti</option>
                                <option value="Lain-Lain">Lain-Lain</option>
                            </select>
                        </div>
                        <textarea id="description-input" onChange={handleProductInformationInput} placeholder="Informasi Produk" type="text"></textarea>
                    </div>
                    <div className="seller-section-image-input">
                        <div className="image-upload">
                            <label for="file-input">
                                <img id="output" src={defaultImageUpload} />
                            </label>
                            <input onChange={loadFile} id="file-input" type="file" />
                        </div>
                        <div className="sellnow-btn">
                            <button onClick={handleSellButton} id="sellnow-btn" type="submit">Jual Sekarang</button>
                        </div>
                    </div>
                </div>
                :
                <div>Gabisa masuk</div>
        }

        </>
    )
};

export default SellerSection;